<script setup>
import { useFilters } from '#/general/useFilters'
import TooltipContainer from '#/general/TooltipContainer'
import { computed, inject } from 'vue'
import AppMenu from '#/general/AppMenu'
import { useDetailsReport } from '#/detailsReport/useDetailsReport'

const props = defineProps({
  val: [String, Number],
  label: String,
  smallText: String,
  unit: String,
  clickable: Boolean,
  tooltip: String,
  width: String,
  tooltipOffset: Array

})
defineEmits(['clicked'])
const { prettifyNumber } = useFilters()
const { version } = useDetailsReport()
const { screen, global } = inject('Shared')

const valueText = computed(() => {
  if (props.clickable) {
    return 'Link'
  }
  return props.val
})
</script>

<template lang="pug">
.potential-item--container(:class="`${version === 1 ? 'potential-item--container-v1' : ''} ${clickable ? 'potential-item--container-link' : ''}`")
  .potential-item--label
    .potential-item--label-text {{ label }}
    .potential-item--label-icon
      app-menu(position="fit" :content-width="width ? width : '250px'" attach-to-parent tooltip-mode :offset="tooltipOffset ? tooltipOffset : [0, 0]" v-if="tooltip || $slots.tooltipContent" center-parent)
        template(#parent)
          svg(width='14' height='14' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg')
            circle(cx='11' cy='11' r='9.4' fill='#EB604F' stroke='white' stroke-width='1.2')
            path(d='M9.6 16V9.436H12.312V16H9.6ZM10.956 8.908C10.46 8.908 10.064 8.776 9.768 8.512C9.472 8.248 9.324 7.92 9.324 7.528C9.324 7.136 9.472 6.808 9.768 6.544C10.064 6.28 10.46 6.148 10.956 6.148C11.452 6.148 11.848 6.272 12.144 6.52C12.44 6.768 12.588 7.088 12.588 7.48C12.588 7.896 12.44 8.24 12.144 8.512C11.848 8.776 11.452 8.908 10.956 8.908Z' fill='white')
        template(#content)
          tooltip-container(:title="label" :body="tooltip" v-if="tooltip")
          slot(name="tooltipContent")

  .potential-item--value-container
    component.potential-item--value(:is="clickable ? 'a' : 'div'" v-if="val && !$slots.default" :class="clickable ? (version === 1 ? 'linkText' : 'linkBox') : ''" :href="val" target="_blank" @click="$emit('clicked')") {{ valueText }} {{unit}}
      .potential-item--value-small-text(v-if="smallText") {{ smallText }}
    slot(v-else)
</template>

<style scoped lang="sass">
.potential-item--container-v1
  margin-bottom: 6px !important
  @media screen and (max-width: 600px)
    flex-direction: column !important
  .potential-item--value
    font-weight: 500 !important
  .potential-item--value-container
    @media screen and (max-width: 600px)
      width: 100% !important
  .potential-item--label
    display: flex
    flex-direction: row
    align-items: center
    padding-right: 10px
    @media screen and (max-width: 600px)
      width: 100%
.potential-item--container-link
  @media screen and (max-width: 400px) and (min-width: 350px)
    flex-direction: row !important
    .potential-item--value-container
      width: auto !important
  @media screen and (max-width: 350px)
    flex-direction: column
.potential-item--container
  display: flex
  width: 100%
  flex-direction: row
  margin-bottom: 11px
  @media screen and (max-width: 1024px)
    justify-content: space-between
    margin-bottom: 10px
  @media screen and (max-width: 400px)
    flex-direction: column
  .potential-item--label
    display: flex
    flex-direction: row
    align-items: center
    padding-right: 10px
    @media screen and (max-width: 400px)
      width: 100% !important
    @media screen and (min-width: 1023px)
      max-width: 60%
      flex: 1
    .potential-item--label-text
      font-style: normal
      color: #626C85
      position: relative
      @media screen and (min-width: 1024px)
        font-weight: 600
        font-size: 16px
        line-height: 200%
      @media screen and (max-width: 1023px)
        font-size: 14px
        font-weight: 500
    .potential-item--label-icon
      margin-left: 8px
  .potential-item--value-container
    display: flex
    align-items: center
    @media screen and (min-width: 1023px)
      max-width: 60%
      flex: 0.8
    @media screen and (max-width: 400px)
      width: 100%
    .potential-item--value
      font-style: normal
      color: v-bind('global.graphicElementColor') !important
      position: relative
      @media screen and (min-width: 1024px)
        font-weight: 500
        font-size: 16px
        line-height: 125%
      @media screen and (max-width: 1023px) and (min-width: 400px)
        font-weight: 600
        font-size: 14px
        text-align: right
      .potential-item--value-small-text
        position: absolute
        top: -4px
        right: -7px
        font-size: 10px
    .linkBox
      font-weight: 700
      border-radius: 15px
      border: 2px solid #1F47CD
      color: v-bind('global.graphicElementColor') !important
      text-decoration: none !important
      cursor: pointer
      @media screen and (min-width: 1024px)
        font-size: 16px
        padding: 3px 10px
      @media screen and (max-width: 1023px)
        font-size: 12px
        padding: 2px 6px
    .linkText
      font-weight: 500
      font-size: 16px
      line-height: 200%
      text-decoration-line: underline
      color: v-bind('global.graphicElementColor') !important
      cursor: pointer
      @media screen and (min-width: 1024px)
        font-size: 16px
      @media screen and (max-width: 1023px)
        font-size: 14px
</style>
